import Vue from 'vue'

export const TownList = function (params) {
  let clientId = window.localStorage.getItem('clientId')
  const townList = window.localStorage.getItem('townList')
  const url = townList ? `/town/list?clientId=${clientId}&townName=${params ? params.townName : ''}&townList=${townList}` : `/town/list?clientId=${clientId}&townName=${params ? params.townName : ''}`
  return Vue.prototype.$axios.get(url)
}



// WEBPACK FOOTER //
// ./src/services/user.js